import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
	fill?: string;
};

export const UserIcon = ({ sx, fill }: Props) => {
	return (
		<SvgIcon width='17' height='20' viewBox='0 0 17 20' fill='none' sx={sx}>
			<path
				d='M8.5 0C10.8517 0 12.75 1.89833 12.75 4.25C12.75 6.60167 10.8517 8.5 8.5 8.5C6.14833 8.5 4.25 6.60167 4.25 4.25C4.25 1.89833 6.14833 0 8.5 0ZM8.5 20.1167C4.95833 20.1167 1.8275 18.3033 0 15.555C0.0425003 12.7358 5.66667 11.1917 8.5 11.1917C11.3192 11.1917 16.9575 12.7358 17 15.555C15.1725 18.3033 12.0417 20.1167 8.5 20.1167Z'
				fill={fill ?? '#1565C0'}
			/>
		</SvgIcon>
	);
};
